import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        meta: { layout: true, needLogin: true },
        component: () => import('../views/Home.vue')
    },
    {
        path: '/add/product',
        name: 'addProduct',
        meta: { layout: true, needLogin: true },
        component: () => import('../components/product/add.vue')
    },
    {
        path: '/edit/product/:id',
        name: 'editProduct',
        meta: { layout: true, needLogin: true },
        component: () => import('../components/product/edit.vue')
    },
    {
        path: '/activity',
        name: 'activity',
        meta: { layout: true, needLogin: true },
        component: () => import('../views/Activity.vue')
    },
    {
        path: '/add/activity',
        name: 'addActivity',
        meta: { layout: true, needLogin: true },
        component: () => import('../components/activity/add.vue')
    },
    {
        path: '/edit/activity/:id',
        name: 'editActivity',
        meta: { layout: true, needLogin: true },
        component: () => import('../components/activity/edit.vue')
    },
    {
        path: '/slider',
        name: 'slider',
        meta: { layout: true, needLogin: true },
        component: () => import('../views/Slider.vue')
    },
    {
        path: '/add/slider',
        name: 'addSlider',
        meta: { layout: true, needLogin: true },
        component: () => import('../components/slider/add.vue')
    },
    {
        path: '/edit/slider/:id',
        name: 'editSlider',
        meta: { layout: true, needLogin: true },
        component: () => import('../components/slider/edit.vue')
    },
    {
        path: '/contact',
        name: 'contact',
        meta: { layout: true, needLogin: true },
        component: () => import('../views/Contact.vue')
    },
    {
        path: '/login',
        name: 'login',
        meta: { layout: false, needLogin: false },
        component: () => import('../views/Login.vue')
    },
    {
        path: '*',
        redirect: '/'
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})

router.beforeEach((to, from, next) => {
    if (to.meta.needLogin) {
        let token = localStorage.getItem('uq_token')
        if (token) {
            if (to.meta.lv) {
                if (to.meta.lv === parseInt(store.state.userlv)) {
                    next()
                } else {
                    next('/login')
                }
            } else {
                next()
            }
        } else {
            next('/login')
        }
    } else {
        next()
    }
})

export default router
